const arraysToObject = (keys, values) => {
	const object = values.reduce((result, value, index) => {
		result[keys[index]] = value;
		return result;
	}, {});
	return object;
};

export { arraysToObject };